module.exports = {
	"_args": [
		[
			{
				"raw": "babel-core@^6",
				"scope": null,
				"escapedName": "babel-core",
				"name": "babel-core",
				"rawSpec": "^6",
				"spec": ">=6.0.0 <7.0.0",
				"type": "range"
			},
			"/home/lively4/lively4/lively4-kernel"
		]
	],
	"_from": "babel-core@>=6.0.0 <7.0.0",
	"_id": "babel-core@6.13.2",
	"_inCache": true,
	"_installable": true,
	"_location": "/babel-core",
	"_nodeVersion": "5.11.1",
	"_npmOperationalInternal": {
		"host": "packages-16-east.internal.npmjs.com",
		"tmp": "tmp/babel-core-6.13.2.tgz_1470405096180_0.20206776657141745"
	},
	"_npmUser": {
		"name": "hzoo",
		"email": "hi@henryzoo.com"
	},
	"_npmVersion": "3.10.3",
	"_phantomChildren": {},
	"_requested": {
		"raw": "babel-core@^6",
		"scope": null,
		"escapedName": "babel-core",
		"name": "babel-core",
		"rawSpec": "^6",
		"spec": ">=6.0.0 <7.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/",
		"/babel-cli",
		"/babel-plugin-transform-regenerator",
		"/babel-register"
	],
	"_resolved": "https://registry.npmjs.org/babel-core/-/babel-core-6.13.2.tgz",
	"_shasum": "f761e1199361d5a6ed16f93ce801ad50acadb338",
	"_shrinkwrap": null,
	"_spec": "babel-core@^6",
	"_where": "/home/lively4/lively4/lively4-kernel",
	"author": {
		"name": "Sebastian McKenzie",
		"email": "sebmck@gmail.com"
	},
	"dependencies": {
		"babel-code-frame": "^6.8.0",
		"babel-generator": "^6.11.4",
		"babel-helpers": "^6.8.0",
		"babel-messages": "^6.8.0",
		"babel-register": "^6.9.0",
		"babel-runtime": "^6.9.1",
		"babel-template": "^6.9.0",
		"babel-traverse": "^6.13.0",
		"babel-types": "^6.13.0",
		"babylon": "^6.7.0",
		"convert-source-map": "^1.1.0",
		"debug": "^2.1.1",
		"json5": "^0.4.0",
		"lodash": "^4.2.0",
		"minimatch": "^3.0.2",
		"path-exists": "^1.0.0",
		"path-is-absolute": "^1.0.0",
		"private": "^0.1.6",
		"shebang-regex": "^1.0.0",
		"slash": "^1.0.0",
		"source-map": "^0.5.0"
	},
	"description": "Babel compiler core.",
	"devDependencies": {
		"babel-helper-fixtures": "^6.9.0",
		"babel-helper-transform-fixture-test-runner": "^6.13.2",
		"babel-polyfill": "^6.13.0"
	},
	"directories": {},
	"dist": {
		"shasum": "f761e1199361d5a6ed16f93ce801ad50acadb338",
		"tarball": "https://registry.npmjs.org/babel-core/-/babel-core-6.13.2.tgz"
	},
	"homepage": "https://babeljs.io/",
	"keywords": [
		"6to5",
		"babel",
		"classes",
		"const",
		"es6",
		"harmony",
		"let",
		"modules",
		"transpile",
		"transpiler",
		"var"
	],
	"license": "MIT",
	"maintainers": [
		{
			"name": "amasad",
			"email": "amjad.masad@gmail.com"
		},
		{
			"name": "hzoo",
			"email": "hi@henryzoo.com"
		},
		{
			"name": "jmm",
			"email": "npm-public@jessemccarthy.net"
		},
		{
			"name": "loganfsmyth",
			"email": "loganfsmyth@gmail.com"
		},
		{
			"name": "sebmck",
			"email": "sebmck@gmail.com"
		},
		{
			"name": "thejameskyle",
			"email": "me@thejameskyle.com"
		}
	],
	"name": "babel-core",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "https://github.com/babel/babel/tree/master/packages/babel-core"
	},
	"scripts": {
		"bench": "make bench",
		"test": "make test"
	},
	"version": "6.13.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/package.json
// module id = 505
// module chunks = 0